import { TableItemContainer, TableItemTextView } from "components/shared";
import React from "react";

/**
 * @function ImportFileMappingPreviewTableRow
 * @return {React.Component}
 * @exported true
 * @description The Import File Mapping Preview table row for the ImportFileMappingPreviewTable.
 */
export default function ImportFileMappingPreviewTableRow(props) {
    const achToParticipant = props.data;
    const participant = achToParticipant.participant;
    const dataPointParticipant = props.dataPoint ? { "data-point": `Mapping_Preview_Participant_Name_Value_${ participant.id }` } : {};
    const dataPointParticipantAccountNumber = props.dataPoint ? { "data-point": `Mapping_Preview_Participant_Account_Number_Value_${ participant.id }` } : {};
    const dataPointParticipantRouting = props.dataPoint ? { "data-point": `Mapping_Preview_Participant_Routing_Value_${ participant.id }` } : {};
    const dataPointParticipantAmount = props.dataPoint ? { "data-point": `Mapping_Preview_Participant_Amount_Value_${ participant.id }` } : {};
    const dataPointParticipantTransactionCode = props.dataPoint ? { "data-point": `Mapping_Preview_Participant_Transaction_Code_Value_${ participant.id }` } : {};

    return (
        <TableItemContainer>
            <TableItemTextView className="column-item column-one" { ...dataPointParticipant } text={participant.participantName} />
            <TableItemTextView className="column-item column-two" { ...dataPointParticipantAccountNumber } text={participant.number} />
            <TableItemTextView className="column-item column-three" { ...dataPointParticipantRouting } text={participant.routing} />
            <TableItemTextView className="column-item column-four" { ...dataPointParticipantAmount } text={achToParticipant.amount.format({hasCents: false}).slice(1)} />
            <TableItemTextView className="column-item column-five" { ...dataPointParticipantTransactionCode } text={participant.transactionCode} />
        </TableItemContainer>
    )
}
